const ColorIcon = ({value,children,onClick,className}) => {
    className = className ? className : 'w-6 h-6 rounded-full'

    return <div onClick={onClick?onClick : ()=>{}} className={className+' chess overflow-hidden relative'}>
        <div className='absolute inset-0 w-full h-full items-center justify-center flex' style={{backgroundColor:value}}>{children}</div>
        </div>
}

export default ColorIcon